import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Services = () => {
  const { language } = useLanguage();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/services`).then(res => setServices(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white font-body" data-testid="services-page">
      <Navbar />

      {/* Hero Banner */}
      <PageHero
        kicker={language === 'en' ? 'Hospital · Departments' : 'अस्पताल · विभाग'}
        title={language === 'en' ? 'Our Services' : 'हमारी सेवाएं'}
        subtitle={language === 'en'
          ? 'Comprehensive healthcare services for all your medical needs'
          : 'आपकी सभी चिकित्सा आवश्यकताओं के लिए व्यापक स्वास्थ्य सेवाएं'}
        testId="services-hero"
      />

      {/* Services — Alternating rows */}
      {loading ? (
        <div className="py-20 text-center text-neutral-400 font-body">Loading...</div>
      ) : (
        <div data-testid="services-grid">
          {services.map((service, index) => {
            const isEven = index % 2 === 0;
            const isDark = !isEven;
            return (
              <Reveal key={service.id} className={isDark ? 'bg-brand-navy text-white' : 'bg-white text-brand-navy'} data-testid={`service-card-${index}`}>
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div className={`relative h-72 sm:h-96 md:h-[480px] lg:h-[560px] overflow-hidden ${!isEven ? 'md:order-2' : ''}`}>
                    {service.image_url ? (
                      <img src={service.image_url} alt={language === 'en' ? service.name_en : service.name_hi}
                        className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                    ) : (
                      <div className={`absolute inset-0 ${isDark ? 'bg-neutral-900' : 'bg-neutral-100'}`}></div>
                    )}
                  </div>
                  <div className={`flex items-center md:h-[480px] lg:h-[560px] ${!isEven ? 'md:order-1' : ''}`}>
                    <div className="px-10 md:px-16 lg:px-20 py-16 md:py-12 w-full">
                      <h3 className="font-heading font-light text-2xl lg:text-3xl uppercase tracking-wide mb-6">
                        {language === 'en' ? service.name_en : service.name_hi}
                      </h3>
                      <div className={`w-10 h-px mb-6 ${isDark ? 'bg-brand-teal-light' : 'bg-brand-teal'}`}></div>
                      <p className={`font-body font-light leading-relaxed text-sm ${isDark ? 'text-neutral-300' : 'text-neutral-600'}`}>
                        {language === 'en' ? service.description_en : service.description_hi}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Services;
